import type { IPatientFilesFilter, TFileWithType } from "./types";
import type { TFile } from "@/api/shared/file";
import { createPathParamCRUD, createPathParam } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";

export * from "./types";

const BASE_SLUG = "patient";
const FILES_SLUG = `${BASE_SLUG}/{patientId}/files`;

export default createService(FILES_SLUG, {
  ...createPathParamCRUD<TFileWithType, { patientId: string }, IPatientFilesFilter>(FILES_SLUG),

  uploadPhoto: createPathParam<TFile, { patientId: string }>(`${FILES_SLUG}/add-photo`),
  uploadScan: createPathParam<TFile, { patientId: string }>(`${FILES_SLUG}/add-scan`),
  uploadXray: createPathParam<TFile, { patientId: string }>(`${FILES_SLUG}/add-xray`),
  uploadSupportingDocument: createPathParam<TFile, { patientId: string }>(
    `${FILES_SLUG}/add-supporting-document`
  ),
});
